import React from "react";
import styles from "../../assets/scss/v1/WeddingBook.module.scss"
import flowerRight from "../../assets/images/v1/wedding-card/flowerRight2.png";
import flowerLeft from "../../assets/images/v1/wedding-card/flowerLeft1.png";
import ImageSlider from "../v0/ImageSlider";


const WeddingBook = () => {

    return (
        <>
            <div className={styles.weddingBook}>
                <div className={styles.banner}>
                    <div className={styles.subBanner}>
                        <div className={styles.weddingBookTxt}>ẢNH CƯỚI</div>
                    </div>
                    <img className={styles.flowerLeft} src={flowerLeft} alt="flowerLeft"/>
                    <img className={styles.flowerRight} src={flowerRight} alt="flowerRight"/>

                </div>

                <div className={styles.container}>
                    <ImageSlider />
                </div>
            </div>
        </>
    )
}

export default WeddingBook;